import { Controller, useFormContext } from 'react-hook-form';

import { TextareaField } from '@nesso/ui/primitives/textarea-field';

import { type AddClientContactInput, MAX_CONTACT_NOTES_LENGTH } from '@/entities/client';

export function AddClientContactFormNotes() {
    const {
        control,
        formState: { isSubmitting },
    } = useFormContext<AddClientContactInput>();

    return (
        <Controller
            control={control}
            name="notes"
            render={({ field, fieldState }) => (
                <TextareaField
                    {...field}
                    value={field.value ?? ''}
                    id={field.name}
                    label="Additional notes"
                    disabled={isSubmitting}
                    maxLength={MAX_CONTACT_NOTES_LENGTH}
                    className="h-19.75"
                    // Informational, so it rides the description slot and never counts as an error
                    // that would hold the save (FR-026).
                    description={
                        (field.value ?? '').length >= MAX_CONTACT_NOTES_LENGTH
                            ? `Maximum ${MAX_CONTACT_NOTES_LENGTH.toLocaleString('en-US')} characters`
                            : undefined
                    }
                    error={fieldState.error?.message ?? fieldState.invalid}
                />
            )}
        />
    );
}
